import { useEffect, useState } from "react";
import { TrendingDown, TrendingUp } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, rupiah } from "@/lib/api";

const STATUS = {
  aktif: ["Aktif", "bg-emerald-50 text-emerald-700"],
  berakhir: ["Berakhir", "bg-sage-100 text-muted2"],
  belum_mulai: ["Belum mulai", "bg-amber-50 text-amber-700"],
  menunggu: ["Menunggu persetujuan", "bg-amber-50 text-amber-700"],
};
const fmtDate = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "–");

const Uplift = ({ p }) => {
  if (p === null || p === undefined) return <span className="text-muted2">Belum ada data sebelum promo</span>;
  const up = p >= 0;
  const Icon = up ? TrendingUp : TrendingDown;
  return <span className={`inline-flex items-center gap-1 font-semibold ${up ? "text-emerald-700" : "text-red-700"}`}><Icon className="w-4 h-4" />{up ? "+" : ""}{String(p).replace(".", ",")}%</span>;
};

const ResultCard = ({ r }) => {
  const [label, cls] = STATUS[r.status];
  const started = r.status === "aktif" || r.status === "berakhir";
  return (
    <div className="card-paper p-5 text-sm" data-testid={`promo-result-${r.menu_id}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="font-semibold text-base">{r.name} <span className="text-muted2 font-normal">· {rupiah(r.price)}</span></div>
        <span className={`text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${cls}`} data-testid={`promo-result-status-${r.menu_id}`}>{label}</span>
      </div>
      <div className="text-xs text-muted2 mt-0.5">{fmtDate(r.promo_start)} – {r.promo_end ? fmtDate(r.promo_end) : "tanpa batas"}{started && ` · ${r.days} hari berjalan`}</div>
      {started && (
        <>
          <div className="grid grid-cols-2 gap-3 mt-4">
            <div className="rounded-xl bg-sage-50 p-3"><div className="text-xs text-muted2">Terjual</div><div className="text-2xl font-bold text-forest" data-testid={`promo-result-sold-${r.menu_id}`}>{r.sold}x</div><div className="text-xs">{rupiah(r.revenue)}</div></div>
            <div className="rounded-xl bg-sage-50 p-3"><div className="text-xs text-muted2">Penjualan gerai / hari</div><div className="font-semibold">{rupiah(r.sales_during_per_day)}</div><div className="text-xs text-muted2">sebelum: {rupiah(r.sales_before_per_day)}</div><div className="text-xs mt-1" data-testid={`promo-result-uplift-${r.menu_id}`}><Uplift p={r.uplift_pct} /></div></div>
          </div>
          {r.by_outlet.length > 0 && <div className="text-xs mt-3">Per gerai: {r.by_outlet.map((o) => `${o.outlet_code} ${o.sold}x`).join(" · ")}</div>}
          {r.components.length > 0 && (
            <table className="w-full text-xs mt-3">
              <thead><tr className="text-left text-muted2"><th className="py-1 font-semibold">Isi paket</th><th className="font-semibold text-right">Via paket</th><th className="font-semibold text-right">Satuan</th><th className="font-semibold text-right">Sebelum</th></tr></thead>
              <tbody>{r.components.map((c) => (
                <tr key={c.menu_id} className="border-t border-sage-200"><td className="py-1.5">{c.name}</td><td className="text-right">{c.via_package}</td><td className="text-right">{c.alone_during}</td><td className="text-right">{c.alone_before}</td></tr>
              ))}</tbody>
            </table>
          )}
          <p className="text-[11px] text-muted2 mt-2">Perbandingan memakai periode dengan jumlah hari sama tepat sebelum promo dimulai, untuk semua gerai.</p>
        </>
      )}
    </div>
  );
};

export const PromoResults = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/promo-results").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  return (
    <div data-testid="promo-results">
      <h2 className="font-serif font-semibold text-2xl">Hasil promo paket</h2>
      <p className="text-sm text-muted2">Jumlah paket terjual dan perubahan penjualan dibanding sebelum promo.</p>
      {rows && rows.length === 0 && <p className="text-center text-muted2 py-12" data-testid="promo-results-empty">Belum ada menu paket. Buat dari tab Ide promo.</p>}
      <div className="grid md:grid-cols-2 gap-4 mt-5 items-start">{rows?.map((r) => <ResultCard key={r.menu_id} r={r} />)}</div>
    </div>
  );
};
